export default __webpack_public_path__ + "c7a77437d7ff19f4ee1e280b320d9929.ttf";